import { IconButton, InputAdornment, Stack, Typography } from '@mui/material';
import { InputText } from '@farmshare/ui-components';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export function ChangePasswordForm() {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <Stack spacing={3}>
      <Typography variant="body2" color="text.secondary">
        Enter your current password and choose a new password.
      </Typography>

      <InputText
        label="Current Password"
        nameOverride="currentPassword"
        type={showCurrentPassword ? 'text' : 'password'}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                edge="end"
              >
                {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <InputText
        label="New Password"
        nameOverride="newPassword"
        type={showNewPassword ? 'text' : 'password'}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowNewPassword(!showNewPassword)}
                edge="end"
              >
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        hint="Must be at least 6 characters"
      />

      <InputText
        label="Confirm New Password"
        nameOverride="confirmPassword"
        type={showConfirmPassword ? 'text' : 'password'}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}
